var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrow = function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 10,
    viewBox: "0 0 12 10"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.134 9.5a1 1 0 0 0 1.732 0l4.33-7.5A1 1 0 0 0 10.33.5H1.67A1 1 0 0 0 .804 2z"
  })));
};
export default SvgArrow;